import { createUserManager } from 'redux-oidc';
import { getUserManagerConfig, getToken } from './sessionUtil';

function createUserManagerConfig(config) {
  console.log('config:',config);
  const userConfigJson = {
    client_id: config.clientId,
    scope: config.scope.join(' '),
    //scope:config.scope[0],
    response_type: config.responseType,
    redirect_uri: config.redirectUri,
    authority: config.authorizationUri,
    post_logout_redirect_uri: config.postLogoutRedirectUri,
    metadata: {
      issuer: config.issuerUri,
      authorization_endpoint: config.authorizationUri,
      userinfo_endpoint: config.userInfoUri,
      jwks_uri: config.jwksUri,
      end_session_endpoint: config.endSessionEndpointUri
    },
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true
  }
  return userConfigJson;
};

//UserManager object
var userManager = null;
export function getUserManager() {
  if (!userManager) {
    return createUserManager(createUserManagerConfig(getUserManagerConfig()));
  }
  return userManager;
}
export function logoutCall() {
  getUserManager().removeUser();
  if (window.location.href.indexOf("localhost") > 0) {
    getUserManager().signoutRedirect({ 'id_token_hint': getToken() });
  } else {
    getUserManager().signoutRedirect();
  }
  sessionStorage.clear();
}